import { BasicCommand } from "../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../common/services/cqs/CommandType";
export class SetArbetsorderVerkligaAvlaggCommand extends BasicCommand<SetArbetsorderVerkligaAvlaggCommand> {
    get primaryKey() {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    anvandVerkligaAvlagg: boolean;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetArbetsorderVerkligaAvlaggCommand";
    constructor(init: (instance: SetArbetsorderVerkligaAvlaggCommand) => void) {
        super("SetArbetsorderVerkligaAvlaggCommand", "Arbetsorder", CommandType.Replace);
        init(this);
    }
}
